import Vue from 'vue'
import firebase from '@firebase/app'
import '@firebase/database'
import {
  SET_CLAIMS,
  SET_FEATURES,
  SET_PREFERENCES,
  SET_USER,
  RESET_USER } from './mutation-types'

const getDefaultState = () => {
  return {
    claims: {},
    email: null,
    preferences: {
      keepScreenOn: true,
      smartQuantities: true,
      system: 'default'
    },
    uid: null
  }
}

export default {
  state: getDefaultState(),
  actions: {
    fetchIdentity ({state, commit, dispatch}, {userId}) {
      const path = `users/${userId}/identity`
      let ref = firebase.database().ref(path)

      return new Promise((resolve, reject) => {
        ref.once('value').then(snapshot => {
          let data = snapshot.val()
          commit(SET_USER, Object.assign(state, {
            displayName: data.displayName
          }))
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setIdentity ({commit}, {uid, identity}) {
      const ref = firebase.database().ref(`users/${uid}/identity`)
      return new Promise((resolve, reject) => {
        ref.set(identity, () => {
          resolve()
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    updateIdentity ({commit}, {user}) {
      let identity = {
        email: user.email,
        displayName: user.displayName,
        identities: user.providerData
      }
      let ref = firebase.database().ref(`users/${user.uid}/identity`)

      ref.once('value', data => {
        if (!data.val()) {
          ref.update(identity, error => {
            if (error) console.log(error)
          })
        }
      })
    },
    fetchPreferences ({state, commit, dispatch}, {userId}) {
      const path = `users/${userId}/preferences`
      let ref = firebase.database().ref(path)

      return new Promise((resolve, reject) => {
        ref.once('value').then(snapshot => {
          commit(SET_PREFERENCES, snapshot.val())
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setFeature ({commit}, {userId, feature}) {
      const ref = firebase.database().ref(`users/${userId}/preferences/features`)
      return new Promise((resolve, reject) => {
        ref.update(feature).then(() => {
          commit(SET_FEATURES, feature)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setPreference ({commit}, {userId, preference}) {
      const ref = firebase.database().ref(`users/${userId}/preferences`)
      return new Promise((resolve, reject) => {
        ref.update(preference).then(() => {
          commit(SET_PREFERENCES, preference)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  getters: {
    isAdminUser: state => state.claims && state.claims.admin
  },
  mutations: {
    [SET_CLAIMS] (state, claims) {
      for (const key in claims) Vue.set(state.claims, key, claims[key])
    },
    [SET_FEATURES] (state, features) {
      for (const key in features) {
        Vue.set(state.preferences.features, key, features[key])
      }
    },
    [SET_PREFERENCES] (state, preferences) {
      for (const key in preferences) {
        Vue.set(state.preferences, key, preferences[key])
      }
    },
    [SET_USER] (state, user) {
      for (const key in user) Vue.set(state, key, user[key])
    },
    [RESET_USER] (state) {
      // Merge rather than replace so we don't lose observers
      // https://github.com/vuejs/vuex/issues/1118
      Object.assign(state, getDefaultState())
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/User.js